export const maxImageWidth = 1920;

export const maxImageHeight = maxImageWidth * 4;

export const acceptableImageExtensions =
  'image/bmp,image/gif,image/vnd.microsoft.icon,image/jpeg,image/png,image/tiff,image/webp';

export const imageEncoding = 'AVIF';
